import MeetingTypeDetails from "./MeetingTypeDetails";

export default MeetingTypeDetails;
